import { MINT_CHAIN_ID } from "@/libs/apis/onboarding/minting/constants";
import { useCurrentUserFavoritedTokens } from "@/src/routes/gallery/routes/collections/routes/[collectionName]/components/CollectionTokenListings/hooks/useCurrentUserFavoritedTokens";
import { useMemo } from "react";
import { NFTContract } from "../types";

export function useCurrentUserNftsWithFavorites(nfts: NFTContract[]) {
  const tokenIds = nfts?.map((nft) => nft.tokenId);

  const currentUserFavoritedTokens = useCurrentUserFavoritedTokens({
    tokenIds: tokenIds as string[],
    /**
     * @note Currently, both the contractAddress and chainId passed in is being ignored by the API
     * @todo remove contract address and chain Id after API has been refactored
     * @see https://jira.nike.com/browse/NVS-2817
     */
    contractAddress: nfts?.at(0)?.contractAddress as string,
    chainId: parseInt(MINT_CHAIN_ID),
  });

  const nftsWithFavorites = useMemo(() => {
    return nfts?.map((item) => {
      const isFavorited =
        currentUserFavoritedTokens?.data?.[item.tokenId] ?? false;
      return { ...item, isFavorited };
    });
  }, [currentUserFavoritedTokens?.data, nfts]);

  return { nftsWithFavorites };
}
